import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  UtilitiesModule,
  PaginationModule,
  TableModule,
} from "@coreui/angular";

import { UserRoutingModule } from "./user.routing";
import { IconModule, IconSetService } from "@coreui/icons-angular";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { SharedAppModule } from "../shared/shared.module";
import { MatPaginatorModule } from "@angular/material/paginator";
import { RouterModule } from "@angular/router";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatTabsModule } from "@angular/material/tabs";
import { UserListComponent } from "./user-list/user-list.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { UserProfileAboutComponent } from "./user-profile-about/user-profile-about.component";

@NgModule({
  declarations: [
    UserListComponent,
    UserProfileComponent,
    UserProfileAboutComponent,
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    UserRoutingModule,
    ReactiveFormsModule,
    AvatarModule,
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    ReactiveFormsModule,
    SidebarModule,
    SharedModule,
    TabsModule,
    ProgressModule,
    BadgeModule,
    ListGroupModule,
    CardModule,
    NgScrollbarModule,
    PaginationModule,
    TableModule,
    MatTableModule,
    MatIconModule,
    MatMenuModule,
    SharedAppModule,
    MatPaginatorModule,
    RouterModule,
    FormsModule,
    ScrollingModule,
    MatTabsModule,
    CommonModule,
  ],
})
export class UserModule {}
